module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "header2"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.user.face,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header_right"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.user.name))]), _vm._v(" "), _c('h2', [_vm._v("\n        加入啦啦操大家庭"), _c('font', {
    staticStyle: {
      "margin-left": "0.12rem",
      "margin-right": "0.12rem",
      "font-size": "0.34rem",
      "font-family": "PingFangSC-Medium, PingFang SC",
      "font-weight": "500",
      "color": "#191919",
      "line-height": "0.48rem"
    }
  }, [_vm._v(_vm._s(_vm.row.days))]), _vm._v("天\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "invite-level"
  }, [(_vm.userDetail.stars.caipan > 0) ? _c('div', {
    staticClass: "level_info"
  }, [_c('img', {
    staticClass: "title-icon",
    staticStyle: {
      "width": "0.25rem",
      "height": "0.25rem"
    },
    attrs: {
      "src": require("../../../../assets/images/font-cai@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.userDetail.stars.caipan == 1) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star1@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.caipan == 2) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star2@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.caipan == 3) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star3@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.caipan == 4) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star4@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.caipan == 5) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star5@2x.png"),
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.yundongyuan > 0) ? _c('div', {
    staticClass: "level_info"
  }, [_c('img', {
    staticClass: "title-icon",
    staticStyle: {
      "width": "0.25rem",
      "height": "0.25rem"
    },
    attrs: {
      "src": require("../../../../assets/images/font-yun@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.userDetail.stars.yundongyuan == 1) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star1@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.yundongyuan == 2) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star2@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.yundongyuan == 3) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star3@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.yundongyuan == 4) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star4@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.yundongyuan == 5) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star5@2x.png"),
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.jiaolian > 0) ? _c('div', {
    staticClass: "level_info"
  }, [_c('img', {
    staticClass: "title-icon",
    staticStyle: {
      "width": "0.25rem",
      "height": "0.25rem"
    },
    attrs: {
      "src": require("../../../../assets/images/font-jiao@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.userDetail.stars.jiaolian == 1) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star1@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.jiaolian == 2) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star2@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.jiaolian == 3) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star3@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.jiaolian == 4) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star4@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetail.stars.jiaolian == 5) ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-star5@2x.png"),
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-top": "0.68rem"
    }
  }, [_c('div', {
    staticClass: "sai_list"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyList'
      }),
      expression: "{name:'ISaiApplyList'}"
    }],
    staticClass: "list_title"
  }, [_c('h1', [_vm._v("我报名的比赛")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.row.sai_list), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "br"
    }), _vm._v(" "), _c('div', {
      staticClass: "list_header"
    }, [_c('h1', [_vm._v(_vm._s(item.saiqu_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ISaiApplyList'
        }),
        expression: "{name:'ISaiApplyList'}"
      }],
      staticClass: "action_btn"
    }, [_vm._v("继续操作")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "br"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaIndex'
      }),
      expression: "{name:'ChaIndex'}"
    }],
    staticClass: "list_title"
  }, [_c('h1', [_vm._v("教练员裁判员优秀证书下载")]), _vm._v(" "), _c('h2', [_vm._v("教练员裁判员优秀证书下载")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "sai_list"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{name:'HuiyiApplyList'}"
    }],
    staticClass: "list_title"
  }, [_c('h1', [_vm._v("我的会议培训")]), _vm._v(" "), _c('h2', [_vm._v("我报名的啦啦操的会议培训")])]), _vm._v(" "), _vm._l((_vm.row.huiyi_list), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "br"
    }), _vm._v(" "), _c('div', {
      staticClass: "list_header"
    }, [_c('h1', [_vm._v(_vm._s(item.station_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiApplyList'
        }),
        expression: "{name:'HuiyiApplyList'}"
      }],
      staticClass: "action_btn"
    }, [_vm._v("继续操作")])])])
  })], 2)]), _vm._v(" "), (_vm.row.kaoji_list.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "sai_list"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.row.kaoji_list), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "br"
    }), _vm._v(" "), _c('div', {
      staticClass: "list_header"
    }, [_c('h1', [_vm._v(_vm._s(item.type_name))]), _vm._v(" "), _c('div', {
      staticClass: "action_btn"
    }, [_vm._v("继续操作")])])])
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("以备案单位为主题发起报名参加的啦啦操比赛 "), _c('br'), _vm._v("管理证书下载")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list_title"
  }, [_c('h1', [_vm._v("我的考级")]), _vm._v(" "), _c('h2', [_vm._v("我报名的考级")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0a7b8cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/activity/Activity.vue
// module id = 2608
// module chunks = 0